import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';
import 'rxjs/add/operator/map';
import { TipoNoticia } from '../../models/tipo-noticias/tipo-noticia';
import { HttpClientService } from '../http-client/http-client.service';

@Injectable()
export class TipoNoticiasService {

    public tipoNoticias: TipoNoticia[];
    public tipoNoticiasObject: any;

    constructor(
        private http: HttpClientService
    ) {
        this.tipoNoticias = [];
        this.tipoNoticiasObject = {};
    }

    public add(addDto: any, desactivados: any): Observable<TipoNoticia[]> {
        const url = 'menus/add';
        return this.http.post(url, {
            data: addDto,
            desactivados: desactivados
        }).map(response => response.json())
            .catch(this.handleError);
    }


    public getAll(): Observable<TipoNoticia[]> {
        const url = 'menus/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            return r.Result;
        }).catch(this.handleError);
    }

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/tipo-noticias/tipo-noticia.service.ts